<template>
  <v-app id="app">
    <span class="bg"
          :style="`background-image: url(${require('@/assets/background.png')})`"
          style="width: 100%; height:75%; position:absolute; overflow: hidden; top:25%; left: 0; background-repeat: no-repeat; background-size: cover;background-position: center top; transform: scale(1);"
    ></span>

    <div id="nav">
      <router-link to="/">Home</router-link>
      |
      <router-link to="/about">About</router-link>
    </div>

    <v-app-bar
        app
        color="white"
        dense
        elevation="1"
        v-if="$route.name != 'Home'"
        class="hidden-sm-and-down"
    >
      <v-img
          aspect-ratio="1.29695"
          width="100%"
          style="top: 40px"
          class="ma-10 elevation-0"
          src="@/assets/logo.png"
          max-height="250"
          max-width="250"
          @click="$router.go()"
      ></v-img>

    </v-app-bar>

    <v-app-bar
        app
        color="white"
        dense
        elevation="1"
        v-if="$route.name != 'Home'"
        class="flex justify-center hidden-md-and-up"
    >
      <v-img
          width="100%"
          style="top: 40px"
          class="ma-10 flex justify-center mx-auto"
          src="@/assets/logo-sm.png"
          max-height="200"
          max-width="200"
          @click="$router.go()"
      ></v-img>
    </v-app-bar>


    <v-main>
      <v-container>
        <router-view/>
      </v-container>
    </v-main>

    <v-footer
        padless
        elevation="2"
    >
      <v-row justify="center" class="text-center" no-gutters>
        <v-col>
          <v-card
              tile
              flat
              color=""
          >
            <v-layout class="flex justify-center grow">

              <v-img
                  contain
                  width="350"
                  max-height="50"
                  max-width="90%"
                  src="@/assets/LogosRfP2021.png"
                  class="mt-4"
              />
            </v-layout>


            <v-card-text class="px-4">
              <span class="mx-2">&copy; {{ $t('copyright') }} {{ new Date().getFullYear() }}</span>
              <span class="mx-2">
                <dialog-modal
                    title="Imprint"
                    btn-ok=""
                    btn-cancel="Close"
                    btn-cancel-icon=""
                    btn-ok-icon=""
                    :body="imprint"

                >Imprint</dialog-modal>
              </span>
              <span class="mx-2">
                <dialog-modal
                    title="Privacy"
                    btn-ok=""
                    btn-cancel="Close"
                    btn-cancel-icon=""
                    btn-ok-icon=""
                    :body="privacy"
                    max-width="80%"
                >Privacy
                </dialog-modal></span>
            </v-card-text>

            <v-card-text class="caption">
              Made with
              <v-icon small>mdi-heart</v-icon>
              by <a class="" style="" href="https://www.limemotion.com" target="_blank">limemotion</a>
              - (v{{ appVersion }})
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>


<script>

import DialogModal from "@/components/DialogModal";
import strings from "@/lang/strings.json"
import {isMobile} from 'mobile-device-detect';

export default {
  name: 'App',
  components: {
    DialogModal
  },
  data: () => ({
    appVersion: process.env.VUE_APP_VERSION,
    imprint: strings.imprint,
    privacy: strings.privacy,
    isMobileDevice: isMobile
  }),

  mounted() {
    // check mediarecorder support for browser
    if ('MediaRecorder' in window) {
      // everything is good, let's go ahead
      this.$store.commit('setBrowserVideoRecordingSupport', true);
    } else {
      this.$store.commit('setBrowserVideoRecordingSupport', false);
      //alert("Sorry, your browser doesn't support Video-Recording.");
    }

    if (this.isMobileDevice) {
      // everything is good, let's go ahead
      this.$store.commit('setIsMobile', true);
    }
  }
};
</script>

<style lang="scss">

#app {
  background-color: var(--v-background-base);
}

.v-btn {
  font-family: 'Montserrat', serif;
  font-weight: bold;

}
</style>
